import React, { useEffect, useState } from "react";
import Login from "../../Template/Auth/Login/Login";
import { useNavigate, useSearchParams } from "react-router-dom";

function LoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const accountCode = searchParams.get("accountCode");

  useEffect(() => {
    if (localStorage.getItem("isLogged") == "true") navigate("/");
  }, []);

  return <Login accountCode={accountCode} />;
}

export default LoginPage;
